import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import { formatDateTime } from '@util/date-util'

import { SidebarLayoutDrawer } from '../../../theme/components/SidebarLayoutDrawer'
import type { Contactpersoon } from '../types/Contactpersoon'

const headerCells = [
  { id: 'date', numeric: false, label: 'Datum', fixed: 80 },
  { id: 'status', numeric: false, label: 'Actie' },
  { id: 'naam', numeric: false, label: 'Naam' },
  { id: 'rol', numeric: false, label: 'Rol' },
  { id: 'telefoonnummer', numeric: false, label: 'Telefoonnummer' },
  { id: 'emailadres', numeric: false, label: 'Emailadres' },
  { id: 'email', numeric: false, label: 'Door' },
]

function translateStatus(status: Contactpersoon['status'], index: number) {
  if (status === 'created' && index === 0) return 'Aangemaakt'
  if (status === 'created' && index !== 0) return 'Bijgewerkt'
  if (status === 'cancelled') return 'Verwijderd'
}

export const ContactpersoonLog = ({
  contactpersoon,
  onClose,
  open,
}: {
  contactpersoon?: Contactpersoon
  onClose: () => void
  open: boolean
}) => {
  const { log = [] } = contactpersoon || {}

  return contactpersoon ? (
    <SidebarLayoutDrawer
      open={open}
      onClose={onClose}
      title={`Log van contactpersoon ${contactpersoon.naam}`}
      size="lg"
    >
      <StyledTable headerCells={headerCells} {...({} as any)}>
        {log.map((logEntry, index) => {
          return (
            <TableRow key={`${logEntry.date}-${logEntry.organisatie}`}>
              <TableCell>{formatDateTime(logEntry.date)}</TableCell>
              <TableCell>{translateStatus(logEntry.status, index)}</TableCell>
              <TableCell>{logEntry.naam}</TableCell>
              <TableCell>
                {logEntry.rol}

                <br />
                <Typography variant="caption">
                  {logEntry.contactOrganisatie}
                </Typography>
              </TableCell>
              <TableCell>{logEntry.telefoonnummer}</TableCell>
              <TableCell>{logEntry.emailadres}</TableCell>
              <TableCell>
                {logEntry.organisatie}

                {logEntry.email ? (
                  <Typography variant="caption">
                    <br />
                    {logEntry.email}
                  </Typography>
                ) : (
                  ''
                )}
              </TableCell>
            </TableRow>
          )
        })}
      </StyledTable>
    </SidebarLayoutDrawer>
  ) : (
    <></>
  )
}
